import React from 'react';
import {Button, InputNumber} from "antd";
import PropTypes from 'prop-types';
import * as Styled from "../../styled";

export default class OrderInput extends React.PureComponent {
  static propTypes = {
    id: PropTypes.string,
    value: PropTypes.number,
    onChange: PropTypes.func,
    onRemove: PropTypes.func,
    mapping: PropTypes.object
  };

  incrQty = (qty) => {
    const val = qty + (this.props.value || 0);
    this.onChange(val);
  };

  onChange = (val) => {
    this.props.mapping.orderQty = val;
    this.props.onChange(this.props.id, val);
  };

  onRemove = () => {
    this.props.onRemove(this.props.id);
  };

  render() {
    const { value } = this.props;
    return (
      <Styled.Quantity>
        <div>
          <InputNumber
            style={{ width: 80 }}
            min={0}
            value={value}
            onChange={this.onChange}
          />
        </div>
        <div className="btns">
          <Button type="primary" onClick={() => this.incrQty(1)}>
            +1
          </Button>
          <Button type="primary" onClick={() => this.incrQty(5)}>
            +5
          </Button>
          <Button type="primary" onClick={() => this.incrQty(50)}>
            +50
          </Button>
          <Button
            icon="delete"
            type="danger"
            onClick={this.onRemove}
          />
        </div>
      </Styled.Quantity>
    );
  }
}